var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9173 9.37823L11.755 6.46236V1.9392C11.7523 0.869322 10.922 0.00282477 9.8968 0C8.8716 0.00282477 8.04128 0.869322 8.03857 1.9392V6.58383L1.08273 9.41566C0.430384 9.68048 0.000676704 10.3358 0 11.0667V11.9629C0 12.7383 0.602944 13.3675 1.34597 13.3675H8.03857V17.8871L5.56183 19.1851C5.0401 19.5064 4.71731 20.089 4.71054 20.7211V21.5396L9.98884 20.4421L14.6662 22L14.7576 21.2408C14.8252 20.6653 14.5728 20.0876 14.0809 19.7049L11.755 17.8871V13.3315H18.654C19.3971 13.3315 20 12.7023 20 11.9269V11.0293C20 10.2984 19.5696 9.64305 18.9173 9.37823Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.661074d9612cbb6daef7d846bf097488.svg";
export { ForwardRef as ReactComponent };